import { render, staticRenderFns } from "./UncleCake.vue?vue&type=template&id=1b5a7496&scoped=true"
import script from "./UncleCake.vue?vue&type=script&lang=js"
export * from "./UncleCake.vue?vue&type=script&lang=js"
import style0 from "./UncleCake.vue?vue&type=style&index=0&id=1b5a7496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5a7496",
  null
  
)

export default component.exports